import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    idInstitucion: parseInt(process.env.VUE_APP_ID_INSTITUCION) || 1,
    esEmpresa: false,
    obraSocialSeleccionada: null,
    urlInstitucion: null,
    nombreInstitucion: null,
  },
  mutations: {
    setObraSocial(state, obraSocial) {
      state.obraSocialSeleccionada = obraSocial;
    },
    setIdInstitucion(state, idInstitucion) {
      state.idInstitucion = idInstitucion;
    },
    setNombreInstitucion(state, nombreInstitucion) {
      state.nombreInstitucion = nombreInstitucion;
    },
    setUrlInstitucion(state, urlInstitucion) {
      state.urlInstitucion = urlInstitucion;
    },
    setEsEmpresa(state, esEmpresa) {
      state.esEmpresa = esEmpresa;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      storage: window.localStorage,
    }),
  ],
});
